import script from "./Article.vue?vue&type=script&setup=true&lang=js"
export * from "./Article.vue?vue&type=script&setup=true&lang=js"

import "./Article.vue?vue&type=style&index=0&id=454993c7&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-454993c7"]])

export default __exports__